

export default {

};



// WEBPACK FOOTER //
// ./src/store/modules/location/mutations.js